import React from 'react';
export var ODHSpace = function (props) {
    var w = props.w, children = props.children;
    return React.createElement("div", { style: { width: w } }, children);
};
//# sourceMappingURL=ODHSpace.js.map